import React, { useContext } from 'react';
import { Card, CardHeader, CardContent, Typography, Grid, Divider } from '@material-ui/core';
import { ExpenseTrackerContext } from '../../context/context';

import useStyles from './styles';
import Form from './Form/Form';
import List from './List/List'
import InfoCard from '../InfoCard';

const ExpenseTracker = ({handleChange, voiceOPT}) => {
    const classes = useStyles();
    const { balance } = useContext(ExpenseTrackerContext);
    return (
        <Card className={classes.root}>
        <CardHeader align="center" title="AI Expense Tracker" subheader="Powered by Spendgram 🤑" />
        <CardContent>
          <Typography align="center" variant="h5">Total Balance ${balance}</Typography>
          <Typography align="center" variant="subtitle1" style={{ lineHeight: '1.5em', marginTop: '20px' }}>
          {voiceOPT && <InfoCard />}
          </Typography>
          <Divider className={classes.divider} />
          <Form />
        </CardContent>
        <CardContent className={classes.cartContent}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <List />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  };

export default ExpenseTracker
